import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { CtrlCollection } from '@yuigoto/ctrl';

import LoginFormStyles from 'components/login/LoginForm.module.scss';
import { TokenActions } from '../../state/actions/user/TokenActions';
import { GlamboxLoginRenderer } from '../renderers/GlamboxLoginRenderer';
import { LoginControl } from '../../controls/LoginControl';
import { GlamboxLocalStore } from 'core/glambox/GlamboxLocalStore';
import { UiActions } from 'state/actions/UiActions';

class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.storageHandle = new GlamboxLocalStore();
    this.collection = new CtrlCollection();
    for (let i in LoginControl) {
      this.collection.add(LoginControl[i]);
    }

    this.submitLogin = this.submitLogin.bind(this);
    this.updateField = this.updateField.bind(this);
  }

  componentDidMount() {
    // Facebook Function
    /*global FB*/
    window.fbAsyncInit = function () {
      FB.init({
        appId:
          document.location.hostname === 'localhost'
            ? '926605097385585'
            : '567750763271022',
        xfbml: true,
        status: true,
        cookie: true,
        version: 'v9.0',
      });
      FB.AppEvents.logPageView();
    };

    // (function (d, s, id) {
    //   let js,
    //     fjs = d.getElementsByTagName(s)[0];
    //   if (d.getElementById(id)) return;
    //   js = d.createElement(s);
    //   js.id = id;
    //   js.src = '//connect.facebook.net/en_US/sdk.js';
    //   fjs.parentNode.insertBefore(js, fjs);
    // })(document, 'script', 'facebook-jssdk');
  }

  submitLogin(evt) {
    evt.preventDefault();
    this.storageHandle.set('loggedWithFacebook', false);
    const { props } = this;

    const isValid = this.collection.validate();
    if (!isValid) {
      this.forceUpdate();
    } else {
      const email = this.collection.getValue('email');
      const password = this.collection.getValue('password');
      const isValidEmailDomain =
        /^\w+([-+.']\w+)*@?(b4a.com.br|b4aconnect.com.br|@b4agroup.com)$/.test(
          email.trim()
        );
      if (!isValidEmailDomain) {
        this.props.publishErrorAlert(
          'Os logins são permitidos apenas com os domínios de e-mail da B4A.'
        );
        return;
      }
      props.executeLogin(email, password);
    }
  }

  updateField(fieldName) {
    return evt => {
      let newStateObject = {};
      newStateObject[fieldName] = evt.currentTarget.value;

      this.setState(newStateObject);
    };
  }

  doLogInWithFacebook = e => {
    e.preventDefault();

    this.props.executeLoginWithFacebook();
  };

  render() {
    return (
      <form
        className={LoginFormStyles['login-form']}
        onSubmit={this.submitLogin}
      >
        {GlamboxLoginRenderer.renderCollection(this.collection)}

        <div className={LoginFormStyles['login-form__submit-group']}>
          <button
            type={'submit'}
            className={classnames(
              'btn',
              'btn-light-lime',
              'login-form__submit',
              'mb-2'
            )}
          >
            Entrar
          </button>
          {/* 
          <button
            type={'button'}
            className={classnames(
              'btn',
              'btn-sm',
              'btn-facebook',
              'login-form__submit'
            )}
            onClick={this.doLogInWithFacebook}
          >
            <i className={'fab fa-2x fa-facebook mr-4'} />
            Continuar com o Facebook
          </button> */}
        </div>

        <div className={'pt-2'}>
          <NavLink to={'/recuperar-senha'} className={LoginFormStyles['link']}>
            Esqueci minha senha
          </NavLink>
        </div>
      </form>
    );
  }
}

// ----------------------------------------------------------------------

const mapStateToProps = state => {
  return {
    loader: state.ui.loader,
    user: state.user,
  };
};

const mapDispatchToProps = dispatch => ({
  executeLogin: (email, password) => {
    dispatch(TokenActions.login(email, password));
  },
  executeLoginWithFacebook: () => {
    dispatch(TokenActions.loginWithFacebook());
  },
  publishErrorAlert: message => {
    dispatch(UiActions.publishErrorAlert(message));
  },
});

LoginForm = connect(mapStateToProps, mapDispatchToProps)(LoginForm);

// ----------------------------------------------------------------------

export { LoginForm };
